<template>
  <div>
    <v-alert :value="true" color="error" icon="warning">
      このページにアクセスする権限がありません。管理者に権限を追加してもらう必要があります。
    </v-alert>
  </div>
</template>

<script>
import { setToolBarTypeLoginLp } from '@/mixins/setToolBarTypeLoginLp'
import { setDrawerTypeLoginLp } from '@/mixins/setDrawerTypeLoginLp'
import { actions as colorThemeActions } from '@/vuex/modules/ui/colorTheme/constants'

export default {
  mixins: [setToolBarTypeLoginLp, setDrawerTypeLoginLp],
  created() {
    this.$store.dispatch(colorThemeActions.INITIALIZE)
  },
}
</script>

<style scoped></style>
